import Layout from "./Layout";
import UserManagementDashboard from "./usemangementCom/UserMangeneentDashboard";

const UserManagement=()=>{
    return <>
<Layout>





<UserManagementDashboard/>
</Layout>
    </>
}

export default UserManagement;